import React from "react";
import {observer} from "mobx-react";
import {UserMenuItemsTitleBox} from "./boxes/user-menu-items-title.box";
import {MenuItemComponentProps} from "../../../services/menu-items-common/menu-item-component-props.interface";
import {UserMenuSectionBox} from "../user-menu/boxes/user-menu-section.box";
import {FlexContainerBox, FlexFixedSizeItemBox, FlexGrowItemBox} from "../../../themes/architecture/css-helpers/flex";
import {useServices} from "../../../react-hooks/use-services.hook";


export const UserMenuItemComponent: React.FC<MenuItemComponentProps> = observer((props) =>  {
    const services = useServices();
    function renderIcon() {
        if(!props.menuItem.iconSource || !props.menuItem.icon) {
            return null;
        }

        if(props.menuItem.iconSource === "themeIcons") {
            const Icon = services.theme.currentTheme.icons[props.menuItem.icon];
            if(!Icon) {
                services.logger.error(`Menu item ${this.props.menuItem.key} has configured icon ${this.props.menuItem.icon} which does not exist in currentTheme.icons`)
                return null;
            }

            return (<Icon size={3.6} style={{marginRight: "0.5rem"}} />);
        }
    }
    const ForwardIcon = services.theme.currentTheme.icons.forwardIcon;
    return (
        <UserMenuSectionBox>
            <FlexContainerBox alignItems="center" onClick={() => props.menuItem.execute()}>
                <FlexFixedSizeItemBox>
                    {renderIcon()}
                </FlexFixedSizeItemBox>
                <FlexGrowItemBox>
                    <UserMenuItemsTitleBox>
                        {props.menuItem.text}
                    </UserMenuItemsTitleBox>
                </FlexGrowItemBox>
                <FlexFixedSizeItemBox>
                    <ForwardIcon size={1.2} />
                </FlexFixedSizeItemBox>
            </FlexContainerBox>
        </UserMenuSectionBox>
    );
});
